import React from 'react';
    
const Options = () => {
    return (
        <div>Options</div>
    )
}
    
export default Options;